export const STORAGE = {
  USER: "0.0.1_crm_u",
}
